import {Slider} from "../components/Slider";

export default class HomePage {
    constructor() {

    }

    init() {
        let slider = new Slider();
        slider.init('.js-slider-dots', true, false, 300);
    }
}


// WEBPACK FOOTER //
// ./static/js/pages/Recommendations.js